import { Component, Input } from '@angular/core';

@Component({
    selector: 'jhi-collapsible',
    template: `
		<label (click)="isCollapsed = !isCollapsed"
			   [attr.aria-expanded]="!isCollapsed">
			<img class="image-icon" *ngIf="img" src="{{img}}">
            <span *ngIf="iconClass" class="{{iconClass}} image-icon"></span>&nbsp;
			<i [ngClass]="isCollapsed?'fa fa-caret-right fa-lg':'fa fa-caret-down fa-lg'" aria-hidden="true"> </i>
			<span [ngClass]="customClass">{{heading}}</span>
            <jhi-help-link [helpKey]="helpKey" [helpTooltipKey]="helpTooltipKey"></jhi-help-link>
		</label><br>
		<section id="{{heading}}" [hidden]="isCollapsed">
			<ng-content></ng-content>
		</section>
    `,
    styles: [`
    .image-icon {
        width: 22px;
        height: 22px;
    }
    `]
})
export class CollapsibleComponent {
    @Input() isCollapsed = false;
    @Input() heading: string;
    @Input() collapsable = true;
    @Input() img: string;
    @Input() iconClass: string;
    @Input() customClass = 'd-inline-flex p-2 h4 fw-bold';
    @Input() helpKey: string;
    @Input() helpTooltipKey: string;
}
